'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var separateStyles = {};

exports.__exports = separateStyles;
